import { BookingStage, createBookingRoute } from '@/components/booking/elements/Detail.vue'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const bookingStore = useBookingStore()

  const bookingUrlQuery = bookingStore.urlQuery
  const pushRoute = createBookingRoute(bookingUrlQuery, BookingStage.SERVICES)

  pushRoute.query['f.category'] = to.params.id

  navigateTo(pushRoute)
})